import commonConfig from './commonConfig';

const configService = {
  commonConfig,
};

export default configService;
